import { render, staticRenderFns } from "./ModalNuevoGrupo.vue?vue&type=template&id=5bfc5e0a&"
import script from "./ModalNuevoGrupo.vue?vue&type=script&lang=js&"
export * from "./ModalNuevoGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports